import { AppStepMapping, JourneyData } from 'App.interface';
import { choosePostContactStep } from 'App.utils';
import { NavigationPath } from 'interfaces';
import { PresetDefinition } from 'presets';

const nextStepMappings: AppStepMapping = {
    'RecommandationHome': (_, journeyData) => journeyData.recommandation?.value === 'advice'
        ? 'Company'
        : 'Catalog',
    'Catalog': () => 'Company',
    'Company': (preset) => preset.type === 'MicroEnt'
        ? 'PreLegalStatus'
        : 'PreEconomicSector',
    'PreEconomicSector': () => 'EconomicSector',
    'EconomicSector': () => 'PreLegalStatus',
    'PreLegalStatus': () => 'LegalStatus',
    'LegalStatus': (preset) => preset.type === 'MicroEnt'
        ? 'HasEmployees'
        : 'NumberOfEmployees',
    'NumberOfEmployees': () => 'Income',
    'HasEmployees': () => 'Income',
    'Income': (preset) => preset.type === 'MicroEnt'
        ? 'HasPeculiarities'
        : 'YearsOfExperience',
    'YearsOfExperience': (_, journeyData) => journeyData.recommandation?.value === 'advice'
        ? 'PreCatalogRecommandation'
        : 'Contact',
    'PreCatalogRecommandation': () => 'CatalogRecommandation',
    'CatalogRecommandation': () => 'Contact',
    'HasPeculiarities': () => 'CumulativeValueOfGoods',
    'CumulativeValueOfGoods': () => 'BusinessPremisesPresence',
    'BusinessPremisesPresence': (_, journeyData) => journeyData.businessPremisesPresence === 'oui'
        ? 'BusinessPremisesOwnership'
        : 'Contact',
    'BusinessPremisesOwnership': () => 'BusinessPremisesSurface',
    'BusinessPremisesSurface': () => 'Contact',
    'Contact': (preset) => preset.pricing ? 'PricingNeeds' : 'PreChooseAdvisor',
    'PreChooseAdvisor': (preset, journeyData) => choosePostContactStep(
        journeyData.folder,
        preset.pricing !== undefined,
    ),
    'ChooseAdvisor': (preset) => {
        if (preset.pricing) {
            return 'PreTarification';
        }

        return 'PreConfirmation';
    },
    'PreTarification': () => 'Tarification',
    'Tarification': () => 'PreConfirmation',
    'PricingNeeds': () => 'PreChooseAdvisor',
};

const previousStepMappings: AppStepMapping = {
    'Catalog': () => 'RecommandationHome',
    'Company': (_, journeyData) => journeyData.recommandation?.value === 'advice'
        ? 'RecommandationHome'
        : 'Catalog',
    'EconomicSector': () => 'Company',
    'LegalStatus': (preset, journeyData) => {
        if (preset.type === 'MicroEnt') {
            return journeyData.company.siretNumber ? 'Company' : 'EconomicSector';
        }
        return 'EconomicSector';
    },
    'NumberOfEmployees': () => 'LegalStatus',
    'HasEmployees': () => 'LegalStatus',
    'Income': (preset) => preset.type === 'MicroEnt'
        ? 'HasEmployees'
        : 'NumberOfEmployees',
    'YearsOfExperience': () => 'Income',
    'HasPeculiarities': () => 'Income',
    'CumulativeValueOfGoods': () => 'HasPeculiarities',
    'BusinessPremisesPresence': () => 'CumulativeValueOfGoods',
    'BusinessPremisesOwnership': () => 'BusinessPremisesPresence',
    'BusinessPremisesSurface': () => 'BusinessPremisesOwnership',
    'CatalogRecommandation': () => 'YearsOfExperience',
    'Contact': (preset, journeyData) => {
        if (preset.type === 'MicroEnt') {
            return journeyData.businessPremisesPresence === 'oui'
                ? 'BusinessPremisesSurface'
                : 'BusinessPremisesPresence';
        }

        if (journeyData.recommandation?.value === 'advice') {
            return 'CatalogRecommandation';
        }

        return 'YearsOfExperience';
    },
    'ChooseAdvisor': () => 'Contact',
};

export function getNextStepFrom(
    currentStep: NavigationPath,
    preset: PresetDefinition,
    journeyData: JourneyData,
): NavigationPath | undefined {
    const getNextStep = nextStepMappings[ currentStep ];
    return getNextStep ? getNextStep(preset, journeyData) : undefined;
}

export function getPreviousStepFrom(
    currentStep: NavigationPath,
    preset: PresetDefinition,
    journeyData: JourneyData,
): NavigationPath | undefined {
    const getPreviousStep = previousStepMappings[ currentStep ];
    return getPreviousStep ? getPreviousStep(preset, journeyData) : undefined;
}
